<!-- src/components/Footer.vue -->
<template>
  <footer class="footer">
    <p>河南屹虎网络科技有限公司</p>
  </footer>
</template>

<script>
export default {
  name: "FooterComponent",
};
</script>

<style scoped>
/* 页脚样式 */
.footer {
  background-color: #f8f8f8;
  padding: 20px;
  text-align: center;
  width: 100%;
}
</style>
